import { __extends } from "tslib";
import { UpdatePushTemplateRequest, UpdatePushTemplateResponse } from "../models/index";
import { deserializeAws_restJson1UpdatePushTemplateCommand, serializeAws_restJson1UpdatePushTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdatePushTemplateCommand = /** @class */ (function (_super) {
    __extends(UpdatePushTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdatePushTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdatePushTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdatePushTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdatePushTemplateResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdatePushTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdatePushTemplateCommand(input, context);
    };
    UpdatePushTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdatePushTemplateCommand(output, context);
    };
    return UpdatePushTemplateCommand;
}($Command));
export { UpdatePushTemplateCommand };
//# sourceMappingURL=UpdatePushTemplateCommand.js.map